import React, { createContext, useContext, useMemo, useState } from "react";
import { useSelector } from "react-redux";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const sessiondata = useSelector((state) => state.user);

  const AppCode = sessiondata?.logindata?.AppCode;
  const userId = sessiondata?.logindata?.UserId;
  const statusApproval =
    sessiondata?.logindata?.crm_app_license_master?.TicketApproval == "Yes";
  /* useState */
  const [userList, setUserList] = useState([]);

  const DepartementList = async () => {
    try {
      const response = await global.$axios.get(`/approval/approvalUsers`);
      if (response.data.Status === 200) {
        setUserList(response.data.userList);
      } else {
        setUserList([]);
      }
    } catch (error) {
      console.log("Context Department List Issue", error);
      setUserList([]);
    }
  };
  const UserApi = async (DeptId) => {
    try {
      let data = {
        DepartmentId: DeptId,
      };
      const response = await global.$axios.put(
        `/ticket/team/user/${AppCode}`,
        data
      );
      if (response.data.Status === 200) {
        setUserList(response.data.Message);
      }
    } catch (error) {
      console.log("Context User List Issue", error);
    }
  };

  const values = useMemo(
    () => ({
      userList,
      DepartementList,
      statusApproval,
    }),
    [userList, statusApproval]
  );

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);
